export function toolkitLogo(toolkits, connections, slug) {
  const key = String(slug ?? '').toLowerCase()
  if (!key) return null
  const toolkit = (toolkits ?? []).find((item) => String(item.slug).toLowerCase() === key)
  if (toolkit?.logo) return toolkit.logo
  const connection = (connections ?? []).find(
    (item) => String(item.toolkit_slug ?? '').toLowerCase() === key,
  )
  return connection?.toolkit_logo ?? null
}
